import { filterNonNullableKeys } from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { Breadcrumbs, BreadcrumbsProps, Container, Link, Typography } from '@mui/material'
import { CategoryBreadcrumbFragment } from '@graphcommerce/magento-category/components/CategoryBreadcrumb/CategoryBreadcrumb.gql'

type CategoryPageBreadcrumbsProps = CategoryBreadcrumbFragment & Omit<BreadcrumbsProps, 'children'> & { linkPrefix?: string };
export function CategoryBreadcrumb(props: CategoryPageBreadcrumbsProps) {
  const { breadcrumbs, name, linkPrefix, ...breadcrumbsProps } = props

  return (
    <Breadcrumbs {...breadcrumbsProps}>
      <Link href='/' underline='hover' color='inherit'>
        <Trans id='Home' />
      </Link>
      {filterNonNullableKeys(breadcrumbs, ['category_level'])
        .sort((a, b) => a.category_level - b.category_level)
        .map((breadcrumb, i) => (
          <Link
            underline='hover'
            key={breadcrumb.category_uid}
            color='inherit'
            href={linkPrefix ? `/${linkPrefix}/${breadcrumb.category_url_path}` : `/${breadcrumb.category_url_path}`}
          >
            {breadcrumb.category_name}
          </Link>
        ))}
      <Typography color='text.primary'>{name}</Typography>
    </Breadcrumbs>
  )
}
